export const timeFormat = 'HH:mm';
export const defaultIntervalFrom = '17:00';
export const defaultIntervalTo = '08:00';
export const defaultIntervalWeekdays = [1, 2, 3, 4, 5];
export const defaultResourceColumnWidth = '448px';
export const compactResourceColumnWidth = '400px';
export const defaultResourceDateColumnMinWidth = '116px';
export const compactResourceDateColumnWidth = '24px';
export const compactResourceHeaderHeight = '34px';
export const compactResourceRowMinHeight = '44px';
export const intervalDateFormat = 'YYYY-MM-DD';

export const intervalRepeatModes = {
  weekly: 'weekly',
  manual: 'manual',
};

export const shiftTypeLabels = {
  day: 'дневная',
  daily: 'суточная',
  fullDay: 'суточная',
  night: 'ночная',
  roundTheClock: 'суточная',
};

const intervalDraftModes = {
  duplicate: 'duplicate',
  edit: 'edit',
};

export const intervalAssignmentPristineDraftModes = new Set([
  intervalDraftModes.duplicate,
  intervalDraftModes.edit,
]);

export const intervalWeekdayOptions = [
  { value: 1, label: 'Пн' },
  { value: 2, label: 'Вт' },
  { value: 3, label: 'Ср' },
  { value: 4, label: 'Чт' },
  { value: 5, label: 'Пт' },
  { value: 6, label: 'Сб' },
  { value: 7, label: 'Вс' },
];
